/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const checkoutB2B = {
  checkoutB2B: {
    noPoNumber: 'Nenhum',
    poNumber: 'Número do pedido de compra (opcional)',
    costCenter: 'Centro de custo',
    placeholder: 'Digite P.O',
    availableLabel:
      "Os endereços de remessa disponíveis dependem da unidade de centro de custo",
    invalid: {
      accountType: 'Sua conta não permite que você pague aqui.',
    },
    methodOfPayment: {
      paymentType: 'Tipo de pagamento',
    },
    review: {
      poNumber: 'Número do pedido de compra',
    },
    progress: {
      methodOfPayment: 'Forma de pagamento',
    },
    invalidCostCenter: 'Centro de custo inválido.',
  },
};
